/**
 * .agents/skills/em/requirements.md 2026-10-27 16:5x: after a production reset (410 production_reset) a device's
 * pre-reset data waits in the replica's `_turso_reset_pending` table until the user chooses "Import your data"; it is
 * never re-expressed on its own. This durable list names those workspaces per user. It is written before the data
 * is captured, so a crash in between never lets the next open re-express it unasked.
 */
function key(userId: string) { return JSON.stringify(['workspace-reset-import', userId]) }

export function readResetImports(storage: Storage, userId: string): string[] {
  const stored = storage.getItem(key(userId))
  return stored === null ? [] : JSON.parse(stored) as string[]
}

export function holdResetImport(storage: Storage, userId: string, workspaceId: string) {
  const held = readResetImports(storage, userId)
  if (!held.includes(workspaceId)) storage.setItem(key(userId), JSON.stringify([...held, workspaceId]))
}

export function releaseResetImport(storage: Storage, userId: string, workspaceId: string) {
  const held = readResetImports(storage, userId).filter(id => id !== workspaceId)
  if (held.length === 0) storage.removeItem(key(userId))
  else storage.setItem(key(userId), JSON.stringify(held))
}
